/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of message, corresponding to the API method of the SDK.
 */
export enum MessageTypeV1 {
    IDENTIFY = 'identify',
    GROUP = 'group',
    TRACK = 'track',
    PAGE = 'page',
    SCREEN = 'screen',
    ALIAS = 'alias',
}